import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./Magazyn.css";

const API_URL = "/api";

function Magazyn({ onLogout }) {
  const [items, setItems] = useState([]);
  const [newItem, setNewItem] = useState({ name: "", quantity: 1 });
  const [filter, setFilter] = useState("");
  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  const fetchItems = async (filterName = "") => {
    try {
      let url = `${API_URL}/inventory`;
      if (filterName) url += `?name=${encodeURIComponent(filterName)}`;
      const res = await fetch(url, {
        headers: { "Authorization": `Bearer ${token}` },
      });
      if (res.status === 401) { if (onLogout) onLogout(); navigate("/login"); return; }
      if (!res.ok) throw new Error("Failed to fetch items");
      const data = await res.json();
      setItems(data.sort((a, b) => a.id - b.id));
    } catch (err) {
      console.error("Error fetching stock items:", err);
    }
  };

  useEffect(() => { fetchItems(); }, []);

  const handleAddItem = async (e) => {
    e.preventDefault();
    if (!newItem.name.trim() || newItem.quantity <= 0) return;
    try {
      const res = await fetch(`${API_URL}/inventory`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        body: JSON.stringify(newItem),
      });
      if (res.status === 401) { if (onLogout) onLogout(); navigate("/login"); return; }
      if (!res.ok) throw new Error("Failed to add item");
      setNewItem({ name: "", quantity: 1 });
      fetchItems(filter);
    } catch (err) {
      console.error("Error adding item:", err);
    }
  };

  const handleQuantityChange = async (item, delta) => {
    const newQuantity = item.quantity + delta;
    if (newQuantity <= 0) {
      try {
        const res = await fetch(`${API_URL}/inventory/${item.id}`, {
          method: "DELETE",
          headers: { "Authorization": `Bearer ${token}` },
        });
        if (res.ok) fetchItems(filter);
      } catch (err) { console.error("Error deleting item:", err); }
    } else {
      try {
        const res = await fetch(`${API_URL}/inventory/${item.id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
          },
          body: JSON.stringify({ quantity: newQuantity }),
        });
        if (res.ok) fetchItems(filter);
      } catch (err) { console.error("Error updating item:", err); }
    }
  };

  const handleGeneratePDF = async () => {
    try {
      const res = await fetch(`${API_URL}/inventory/pdf`, {
        headers: { "Authorization": `Bearer ${token}` },
      });
      if (res.status === 401) { if (onLogout) onLogout(); navigate("/login"); return; }
      if (!res.ok) throw new Error("Failed to generate PDF");
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "stock.pdf"; a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert("Error generating PDF");
    }
  };

  const handleFilterChange = (e) => {
    const value = e.target.value;
    setFilter(value);
    fetchItems(value);
  };

  return (
    <div className="magazyn-page">
      <div className="magazyn-container">
        <h2>Stock</h2>
        <div className="filter-and-buttons">
          <input type="text" placeholder="Filter by name..." value={filter} onChange={handleFilterChange} className="filter-input" />
          <button onClick={handleGeneratePDF} className="generate-pdf-button">Generate PDF</button>
          <button onClick={() => navigate("/form")} className="back-button">Back</button>
        </div>

        <form onSubmit={handleAddItem} className="magazyn-form">
          <input type="text" placeholder="Item name" value={newItem.name}
            onChange={(e) => setNewItem({ ...newItem, name: e.target.value })} required />
          <input type="number" min="1" value={newItem.quantity}
            onChange={(e) => setNewItem({ ...newItem, quantity: parseInt(e.target.value) })} required />
          <button type="submit">Add</button>
        </form>

        {items.length === 0 ? (
          <p className="empty-text">Stock is empty</p>
        ) : (
          <div className="table-container">
            <table className="magazyn-table">
              <thead>
                <tr><th>Item Name</th><th>Amount</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.name}</td>
                    <td>{item.quantity}</td>
                    <td className="actions">
                      <button onClick={() => handleQuantityChange(item, 1)}>+</button>
                      <button onClick={() => handleQuantityChange(item, -1)}>-</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

export default Magazyn;
